module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qresp9-e42f9908c52ae89986fe293110d243fa.jpg";